import axiosInstance from "@/api/axios-instance";

export interface EventType {
  id: string;
  managed_event_id: string;
  professional_id: string | null;
  calendly_event_type_uri: string | null;
  scheduling_url: string | null;
  language: string | null; // deprecated (unused) — superseded by `type`
  type: string | null; // round-robin pool slug (unique per managed event)
  is_active: boolean;
  metadata?: Record<string, any> | null; // schedulingDescription / schedulingTitle overrides
  managed_event?: { id: string; name: string } | null;
  teams?: { id: string; name: string }[];
  professional?: { id: string; name: string } | null;
  created_at: string;
}

export interface EventTypeInput {
  managed_event_id: string;
  team_ids?: string[];
  professional_id?: string | null;
  calendly_event_type_uri?: string | null;
  scheduling_url?: string | null;
  language?: string | null; // deprecated (unused) — superseded by `type`
  type?: string | null; // round-robin pool slug (unique per managed event)
  is_active?: boolean;
  metadata?: Record<string, any> | null; // schedulingDescription / schedulingTitle overrides
}

export interface EventTypesResult {
  eventTypes: EventType[];
  total: number;
  page: number;
  lastPage: number;
  nextPage: number | null;
}

export async function getEventTypes(params?: {
  q?: string;
  type?: "individual" | "round_robin" | "all";
  managed_event_id?: string;
  is_active?: boolean;
  page?: number;
  limit?: number;
}): Promise<EventTypesResult> {
  const r = await axiosInstance.get("/event-type", {
    params: {
      ...params,
      q: params?.q || undefined,
      type: params?.type === "all" ? undefined : params?.type,
    },
  });
  return r.data;
}
export async function getEventType(id: string): Promise<EventType> {
  const r = await axiosInstance.get(`/event-type/${id}`);
  return r.data;
}
export async function getEventTypesByManagedEvent(
  managedEventId: string,
): Promise<EventType[]> {
  const r = await axiosInstance.get("/event-type", {
    params: { managed_event_id: managedEventId, limit: 1000 },
  });
  return r.data.eventTypes ?? [];
}
export async function createEventType(data: EventTypeInput) {
  return (await axiosInstance.post("/event-type", data)).data;
}
// Round-robin: upserts by Calendly uri and connects the teams (so one event
// can map to multiple teams without hitting the unique constraint).
export async function upsertRoundRobinEventType(data: EventTypeInput) {
  return (await axiosInstance.post("/event-type/round-robin", data)).data;
}
export async function updateEventType(id: string, data: Partial<EventTypeInput>) {
  return (await axiosInstance.patch(`/event-type/${id}`, data)).data;
}
export async function deleteEventType(id: string) {
  return (await axiosInstance.delete(`/event-type/${id}`)).data;
}
